/**
 * The one `import()` of the map engine (MapLibre plan D2).
 *
 * The magic comment makes webpack emit a native dynamic `import()` of the
 * root-relative URL and parse nothing: the engine's own module-URL use would
 * otherwise become an empty webpack context, which `CI=true` builds reject.
 * Dropping the comment brings that failure back — the CI build is this
 * line's test (jest mocks this module; `src/setupTests.ts`).
 */
import type * as MapLibre from 'maplibre-gl';
import { engineUrl } from './mapEngine';

export const importEngine = (): Promise<typeof MapLibre> =>
  import(/* webpackIgnore: true */ engineUrl()) as Promise<typeof MapLibre>;
